import styled from "styled-components";
import { Paragraph2, WrapperContainer } from "../../components";
import { colors } from "../../consts";

export const DashboardTemplateWrapper = styled(WrapperContainer)`
  border: ${(props) =>
    props?.theme?.darkMode
      ? `1px solid rgba(110, 110, 116, 0.55)`
      : `1px solid ${colors.RAISIN_20}`};

  box-shadow: unset;
  padding: 16px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const DahsboardTitle = styled(Paragraph2)`
  font-weight: 700;
  min-width: fit-content;
`;
